import Link, { LinkProps } from "next/link";

import classNames from "classnames/bind";
import Button, { ButtonProps } from "common/blocks/Button";
import UIIcon from "common/blocks/UIIcon";

import styles from "./EstimateAvailableWidget.module.scss";

const cx = classNames.bind(styles);

export type EstimateAvailableWidgetType = {
    heading: string;
    body: string;
    cta: { text: string } & ButtonProps;
};

export default function EstimateAvailableWidget({
    heading,
    body,
    cta,
}: EstimateAvailableWidgetType) {
    return (
        <div className={cx("estimateAvailableWidget")}>
            <UIIcon icon="Clock" />
            <div>
                <h5>{heading}</h5>
                <p>{body}</p>
            </div>
            <Button theme="textLink" className={cx("estimateAvailableWidget-cta")} {...cta}>
                {cta.text}
            </Button>
        </div>
    );
}
